import React from 'react';
import { Flex, Typography } from '@banhala/ui-kit';

type ReviewCommentProps = {
  counts: number;
};

export const ReviewComment: React.FC<ReviewCommentProps> = ({ counts }) => {
  if (counts === 0) return null;

  return (
    <Flex
      borderTopWidth={1}
      padding={{ top: 12 }}
      borderColor={'border_secondary'}
    >
      <Typography
        type={'subtitle2'}
        color={'content_secondary'}
        numberOfLines={3}
      >
        댓글 {counts}개 모두 보기
      </Typography>
    </Flex>
  );
};
